import { X } from 'lucide-react'
import { Badge, getStatusVariant } from '@/components/ui/Badge'
import { getStageLabel, stageConfig } from '../deals-constants'
import { getDealAvatarFallback } from '@/utils/dealDisplay'
import type { Deal } from '@/types'
import { DealDetailStageStepper } from './DealDetailStageStepper'
import './deal-detail-panel.css'

type DealDetailHeaderProps = {
  deal: Deal
  onClose: () => void
}

export function DealDetailHeader({ deal, onClose }: DealDetailHeaderProps) {
  const currentStage = stageConfig[deal.etapa]
  const contactLabel =
    deal.nome && deal.nome !== deal.empresaNome ? deal.nome : (deal.closerNome ?? 'Sem contato')

  return (
    <header className="shrink-0 border-b border-white/[0.06] px-4 pb-4 pt-4">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent/10">
          <span className="text-sm font-semibold text-accent">
            {getDealAvatarFallback(deal.empresaNome, deal.closerAvatar)}
          </span>
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <h2 className="truncate text-base font-semibold leading-tight text-text-primary">
                {deal.empresaNome}
              </h2>
              <p className="truncate text-xs text-text-label">{contactLabel}</p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-text-muted transition-colors hover:bg-white/[0.06] hover:text-text-primary"
              aria-label="Fechar painel"
              title="Fechar painel"
            >
              <X size={17} />
            </button>
          </div>

          <div className="mt-2.5 flex flex-wrap items-center gap-2">
            <Badge variant={getStatusVariant(deal.etapa)} className="max-w-full truncate">
              <span
                className="mr-1.5 inline-block h-1.5 w-1.5 shrink-0 rounded-full"
                style={{ backgroundColor: currentStage?.color ?? 'var(--brand-primary)' }}
                aria-hidden
              />
              {getStageLabel(deal.etapa)}
            </Badge>
            {deal.driftDays > 0 && (
              <span className="text-[11px] text-text-label">{deal.driftDays}d no pipeline</span>
            )}
          </div>
        </div>
      </div>

      <div className="mt-3">
        <DealDetailStageStepper deal={deal} />
      </div>
    </header>
  )
}
